import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constant/colors";
import LoadingButton from "./LoadingButton.jsx";

function TestSchedule() {
  const [testSchedules, setTestSchedules] = useState([]);
  const [form, setForm] = useState({
    testName: "",
    subject: "",
    class: "",
    section: "",
    date: "",
    startTime: "",
    endTime: "",
    invigilator: "",
    roomNumber: "",
    additionalNotes: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);

  // LABEL STYLE (18px)
  const labelStyle = "block text-black font-semibold text-[18px] mb-1";

  // INPUT STYLE (14px)
  const inputStyle = {
    background: "#FFFFFF",
    border: "1px solid #1E40AF",
    padding: "12px",
    borderRadius: "8px",
    width: "100%",
    fontSize: "14px",
  };

  // BUTTON STYLE (18px)
  const buttonStyle = {
    background: colors.gradientPrimary,
    color: "white",
    padding: "12px 30px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    alignItems: "center",
  };
useEffect(() => {
  fetchTeachers();
}, []);

const fetchTeachers = async () => {
  const sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) return;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers`,
      {
        params: { sessionId },
      }
    );

    setTeachers(res.data);
  } catch (error) {
    console.error("Error fetching teachers:", error);
  }
};

  // Fetching Data
  useEffect(() => {
    fetchTestSchedules();
    fetchClasses();
  }, []);

  useEffect(() => {
    if (form.class) fetchSections(form.class);
  }, [form.class]);

  useEffect(() => {
    if (form.class && form.section) fetchSubjects(form.class);
  }, [form.class, form.section]);
  const fetchTestSchedules = async () => {
    const sessionId = localStorage.getItem("currentSessionId"); // Retrieve sessionId from localStorage or sessionStorage
    if (!sessionId) {
      console.error("Session ID is not available.");
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/getTestSchedules?sessionId=${sessionId}`
      );
      setTestSchedules(res.data); 
    } catch (error) {
      console.error("Error fetching test schedules:", error);
    }
  };


  const fetchClasses = async () => {
    const sessionId = localStorage.getItem("currentSessionId"); 
    if (!sessionId) {
      console.error("Session ID not found.");
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${sessionId}`);
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSections = async (className) => {
    const sessionId = localStorage.getItem("currentSessionId");  
    if (!sessionId) {
      console.error("Session ID not found.");
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sections/${className}/getSectionsByClassName`, {
        params: { sessionId: sessionId },
      });
      setSections(res.data);
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  const fetchSubjects = async (className) => {
    const sessionId = localStorage.getItem("currentSessionId");
    if (!sessionId) {
      console.error("Session ID not found.");
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${className}`, {
        params: { sessionId: sessionId }
      });
      setSubjects(res.data);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };



  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) {
    console.error("Session ID is not available.");
    setLoading(false);
    return;
  }

  const formData = { ...form, sessionId };

  try {
    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/updateTestSchedule/${editingId}`,
        formData
      );

      // ✅ ALERT FOR UPDATE
      alert("Test schedule updated successfully");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/createTestSchedule`,
        formData
      );

      // ✅ ALERT FOR ADD
      alert("Test schedule added successfully");
    }

    setForm({
      testName: "",
      subject: "",
      class: "",
      section: "",
      date: "",
      startTime: "",
      endTime: "",
      invigilator: "",
      roomNumber: "",
      additionalNotes: "",
    });

    setEditingId(null);
    fetchTestSchedules();
  } catch (error) {
    console.error("Error saving test schedule:", error);
    alert("Failed to save test schedule");
  } finally {
    setLoading(false);
  }
};



  const handleEdit = (schedule) => {
    setForm(schedule);
    setEditingId(schedule._id);
  };

const handleDelete = async (id) => {
  const sessionId = localStorage.getItem("currentSessionId"); 
  if (!sessionId) {
    alert("Session ID is missing.");
    return;
  }

  if (!window.confirm("Are you sure?")) return;

  try {
   
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/testSchedules/deleteTestSchedule/${id}`,
      { params: { sessionId } }
    );
    fetchTestSchedules();  
  } catch (error) {
    console.error("Error deleting test schedule:", error);
    alert("There was an error deleting the test schedule.");
  }
};


  return (
    <div className="min-h-screen bg-white p-6">

      {/* PAGE TITLE */}
      <div className="flex items-center mb-8">

      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">

        {/* Test Name */}
        <div>
          <label className={labelStyle}>Test Name</label>
          <input name="testName" value={form.testName} onChange={handleChange} style={inputStyle} />
        </div>

        {/* Class */}
        <div>
          <label className={labelStyle}>Class</label>
          <select name="class" value={form.class} onChange={handleChange} style={inputStyle}>
            <option value="">Select Class</option>
            {classes.map((c) => (
              <option key={c._id} value={c.className}>{c.className}</option>
            ))}
          </select>
        </div>

        {/* Section */}
        <div>
          <label className={labelStyle}>Section</label>
          <select
            name="section"
            value={form.section}
            onChange={handleChange}
            disabled={!form.class}
            style={inputStyle}
          >
            <option value="">Select Section</option>
            {sections.map((s) => (
              <option key={s._id} value={s.sectionName}>{s.sectionName}</option>
            ))}
          </select>
        </div>

        {/* Subject */}
        <div>
          <label className={labelStyle}>Subject</label>
          <select
            name="subject"
            value={form.subject}
            onChange={handleChange}
            disabled={!form.section}
            style={inputStyle}
          >
            <option value="">Select Subject</option>
            {subjects.map((s) => (
              <option key={s._id} value={s.subjectName}>{s.subjectName}</option>
            ))}
          </select>
        </div>

        {/* Date */}
        <div>
          <label className={labelStyle}>Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} style={inputStyle} />
        </div>

        {/* Start Time */}
        <div>
          <label className={labelStyle}>Start Time</label>
          <input type="time" name="startTime" value={form.startTime} onChange={handleChange} style={inputStyle} />
        </div>

        {/* End Time */}
        <div>
          <label className={labelStyle}>End Time</label>
          <input type="time" name="endTime" value={form.endTime} onChange={handleChange} style={inputStyle} />
        </div>

        {/* Invigilator */}
        <div>
          <label className={labelStyle}>Invigilator</label>
         <select
  name="invigilator"
  value={form.invigilator}
  onChange={handleChange}
  style={inputStyle}
>
  <option value="">Select Invigilator</option>
  {teachers.map((t) => (
    <option key={t._id} value={`${t.firstName} ${t.lastName}`}>
      {t.firstName} {t.lastName}
    </option>
  ))}
</select>
        </div>

        {/* Room Number */}
        <div>
          <label className={labelStyle}>Room Number</label>
          <input name="roomNumber" value={form.roomNumber} onChange={handleChange} style={inputStyle} />
        </div>

        {/* Notes */}
        <div className="md:col-span-3">
          <label className={labelStyle}>Additional Notes</label>
          <textarea
            rows="3"
            name="additionalNotes"
            value={form.additionalNotes}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        {/* Submit Button */}
        <div className="md:col-span-3 flex justify-center">
          <LoadingButton
  type="submit"
  loading={loading}
  text={editingId ? "Update Test Schedule" : "Add Test Schedule"}
  style={buttonStyle}
/>

        </div>
      </form>

      {/* TABLE */}
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 text-center">
          <thead className="bg-gray-200">
            <tr>
              {[
                "#",
                "Test Name",
                "Class (Section)",
                "Subject",
                "Date",
                "Timing",
                "Invigilator",
                "Room",
                "Actions",
              ].map((head) => (
                <th key={head} className="py-3 px-4 border-b text-black font-semibold text-[18px]">
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {testSchedules.length ? (
              testSchedules.map((t, i) => (
                <tr key={t._id} className="even:bg-gray-50">
                  <td className="border px-4 py-2 text-[14px]">{i + 1}</td>
                  <td className="border px-4 py-2 text-[14px]">{t.testName}</td>
                  <td className="border px-4 py-2 text-[14px]">
                    {t.class} ({t.section})
                  </td>
                  <td className="border px-4 py-2 text-[14px]">{t.subject}</td>
                  <td className="border px-4 py-2 text-[14px]">
                    {new Date(t.date).toLocaleDateString()}
                  </td>
                  <td className="border px-4 py-2 text-[14px]">
                    {t.startTime} - {t.endTime}
                  </td>
                  <td className="border px-4 py-2 text-[14px]">{t.invigilator}</td>
                  <td className="border px-4 py-2 text-[14px]">{t.roomNumber}</td>

                  <td className="border px-4 py-2 flex flex-col md:flex-row gap-2 justify-center">
                    <button className="px-3 py-1 rounded text-white bg-yellow-500 text-[14px]" onClick={() => handleEdit(t)}>
                      Edit
                    </button>
                    <button className="px-3 py-1 rounded text-white bg-red-600 text-[14px]" onClick={() => handleDelete(t._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-gray-500 py-4 text-[14px]">
                  No test schedules available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TestSchedule;
